import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import CommonLoader from '../../../../../components/common-loader/CommonLoader';
import CommonPagination from '../../../../../components/common-pagination/CommonPagination';
import EmptySessionsDisclaimer from '../empty-sessions-disclaimer/EmptySessionsDisclaimer';
import SessionCard from '../session-card/SessionCard';

import scss from './SessionList.module.scss';

function SessionList({ onSelectSession, onChangePage }) {
  const listRef = useRef(null);

  const sessionsData = useSelector((state) => state.story.sessionsData);
  const isSessionsLoading = useSelector((state) => state.story.isSessionsLoading);
  const sessionId = useSelector((state) => state.story.sessionId);
  const { page, size, totalElements } = useSelector((state) => state.story.sessionsTableSettings);

  const hasSessions = sessionsData.length > 0;

  useEffect(() => {
    listRef.current.scrollTop = 0;
  }, [page]);

  return (
    <div className={scss.wrapper}>
      <div className={scss.listArea} ref={listRef}>
        {!isSessionsLoading && !hasSessions ? <EmptySessionsDisclaimer /> : null}

        {hasSessions ? (
          <ul className={scss.list}>
            {sessionsData.map((session) => (
              <SessionCard
                key={session.id}
                session={session}
                isActive={session.id === sessionId}
                onSelect={onSelectSession}
              />
            ))}
          </ul>
        ) : null}

        <CommonLoader
          isLoading={isSessionsLoading}
          disableScrolling
          scrollableRef={listRef}
          width={40}
          strokeWidth='4'
        />
      </div>

      {hasSessions && totalElements > size ? (
        <CommonPagination
          activePage={page}
          itemsPerPage={size}
          totalItemsCount={totalElements}
          onChangePage={onChangePage}
        />
      ) : null}
    </div>
  );
}

export default SessionList;
